import { SectionMessageVariant } from '@billy/design-system/src/components/SectionMessage/types'

import { CegidIntegrationStatus } from '@features/cegidIntegration/enums/cegidIntegrationStatus'

export const cegidIntegrationStatusToMessageVariant: Record<CegidIntegrationStatus, SectionMessageVariant> = {
  [CegidIntegrationStatus.Failed]: 'error',
  [CegidIntegrationStatus.Pending]: 'info',
  [CegidIntegrationStatus.Processing]: 'info',
  [CegidIntegrationStatus.Posted]: 'success',
}
